import styled from '@emotion/styled'

const ChatHeader = styled.div`
  display:flex;
  justify-content: space-between;
  align-items: center;
  height: 86px;
  padding: 55px 23px 11px 35px;
  border-bottom: 1px solid rgba(144, 161, 176, 0.16);
`

export default ChatHeader
